import React, {Component} from 'react'
import Select from '../core/control/Select';

export default class EncodingSelector extends Component {
	render() {
		const options = this.props.context.encoding.map(encoding => ({key: encoding, value: encoding}))
		const onChange = this.props.onChange

		return (
			<Select
				options={options}
				onChange={onChange}
			/>
		)
	}
}